/*
 * Copyright © 2024-present Mia s.r.l.
 * All rights reserved
 */

/**
 * The preview log stream's 'initial' event resends the FULL buffered
 * stdout/stderr replay on every reconnect (a network blip, or the dev
 * server process itself restarting) — not just what was missed. Each
 * replay is cumulative, so the previous one is normally an exact PREFIX of
 * the new one. Diffing against it (rather than a content Set, which would
 * wrongly collapse a legitimately-repeated line like "Compiling...") finds
 * only the genuinely new suffix, so a reconnect's replay can be merged in
 * instead of wholesale-replacing already-shown live lines (and their real
 * timestamps).
 *
 * @param {Array<{type: string, line: string}>} previousReplay - the last replay batch merged in, or [] on first connect.
 * @param {Array<{type: string, line: string}>} incomingReplay - the new replay batch just received.
 * @returns {Array<{type: string, line: string}>} only the entries in `incomingReplay` beyond where it stops matching `previousReplay`.
 */
export function newlyReplayedEntries(previousReplay, incomingReplay) {
  let commonPrefixLength = 0;
  while (
    commonPrefixLength < previousReplay.length &&
    commonPrefixLength < incomingReplay.length &&
    previousReplay[commonPrefixLength].type === incomingReplay[commonPrefixLength].type &&
    previousReplay[commonPrefixLength].line === incomingReplay[commonPrefixLength].line
  ) {
    commonPrefixLength += 1;
  }
  return incomingReplay.slice(commonPrefixLength);
}
